import React from 'react';

import { CA } from 'contexts';
import { useForm } from 'components/form';
import { RHP } from 'providers';
import { isValidCPF, isValidCNPJ } from 'utils/validation';

import * as Page from 'components/page';

import { OiweekPayPerUseForm } from './OiweekPayPerUseForm';
import * as Styled from './StyledOiweekPayPerUse';

export const OiweekPayPerUse = props => {
    const { vars, postOiweekPayPerUse } = props.useOiweek;
    const { oiweekPayPerUseTerm } = vars;

    const { state } = React.useContext(CA);

    // Initialize a new form handler
    const form = useForm({
        email: state.user.email,
        name: state.user.fullName,
        taxIdType: 'CPF',
        taxId: '',
    });

    // Handle blur for CPF/CNPJ inputs
    const onBlur = {
        isValidCPF: ev => {
            const { name, value } = ev.target;
            // Clear the errors and warnings before validating
            form.clearMessages({ name });
            // Only check if the value is filled
            if (!value) return false;
            // Check if the CPF is a valid one
            const cleanValue = value.replace(/[^0-9]/g, '');
            if (!isValidCPF(cleanValue)) {
                // Emit error message for registered email
                const error = props.t('OiweekPayPerUse.notValidCPF');
                return form.emitError({ name, error });
            }
            return true;
        },
        isValidCNPJ: ev => {
            const { name, value } = ev.target;
            // Clear the errors and warnings before validating
            form.clearMessages({ name });
            // Only check if the value is filled
            if (!value) return false;
            // Check if the CPF is a valid one
            const cleanValue = value.replace(/[^0-9]/g, '');
            if (!isValidCNPJ(cleanValue)) {
                // Emit error message for registered email
                const error = props.t('OiweekPayPerUse.notValidCNPJ');
                return form.emitError({ name, error });
            }
            return true;
        },
    };

    // Handle change on form fields
    const onChange = {
        taxIdType: ev => {
            const { value } = ev.target;
            const newEvent = { ...ev };
            newEvent.target.name = 'taxId';
            newEvent.target.value = form.values.taxId;
            if (value === 'CPF') {
                return onBlur.isValidCPF(newEvent);
            }
            if (value === 'CNPJ') {
                return onBlur.isValidCNPJ(newEvent);
            }
            form.clearMessages({ name: newEvent.target.name });
            return false;
        },
    };

    // Handle form submitions
    const onSubmit = values => {
        const termId = oiweekPayPerUseTerm._id;
        const payload = { ...values, signed: true, termId };
        postOiweekPayPerUse(payload).then(res => {
            RHP.push('/oiweek');
            return true;
        });
    };

    const propsForm = { ...props, form, onBlur, onChange, onSubmit };
    return (
        <Styled.OiweekPayPerUse>
            <Page.Page name="OiweekPayPerUse">
                <Page.Title>{props.t('OiweekPayPerUse.title')}</Page.Title>
                <Page.Descr>{oiweekPayPerUseTerm.htmlFriendly}</Page.Descr>

                <OiweekPayPerUseForm {...propsForm} />
            </Page.Page>
        </Styled.OiweekPayPerUse>
    );
};
export default OiweekPayPerUse;
